// Input que será usado para quando não precisar ter controle sobre o valor do input. Será passado apenas o defaultValue

import { InputAdornment, TextField } from "@mui/material"

import { SxOneTextField, SxOneInputProps } from './OneInputStyle'

// const transformText = (text, value) => {
//     if (value == undefined) {
//         return ""
//     }
//     let result = value
//     switch (text) {
//         case "uppercase":
//             result = value.toUpperCase()
//             break
//         default:
//             break
//     }
//     return result
// }

const OneInput = ({
    name = "",
    type = 'text',
    defaultValue,
    StartIcon = false,
    EndIcon = false,
    IconCallback = false,
    maxLength = "",
    // FullWidth = false,
    textarea = false,
    // maxLength = 255,
    // readOnly = false,
    // disabled = false,
    // required,
    transform = false,
    disabled = false,
    readOnly = false,
    placeholder,
    onBlur = () => {},
    newSx = {},
    ...rest
}) => {
    return (
        <TextField
            variant="outlined"
            sx={{ ...SxOneTextField, ...newSx, backgroundColor: (disabled || readOnly ? "#c9c7c7" : "#fff") }}
            name={name}
            {...rest}
            defaultValue={defaultValue || ""}
            type={type}
            multiline={textarea}
            onBlur={onBlur}
            inputProps={{
                maxLength,
                disabled,
                readOnly,
                // required,
                sx: { padding: '0 5px' },
                ...rest
            }}
            InputProps={{
                sx: textarea ? { ...SxOneInputProps, ...newSx, height: '100%', padding: '0 4px', margin: 0 } : { ...SxOneInputProps, ...newSx },
                placeholder: placeholder || "",
                startAdornment: (
                    StartIcon && <InputAdornment position="start">
                        <StartIcon onClick={() => IconCallback()} />
                    </InputAdornment>
                ),
                endAdornment: (
                    EndIcon && <InputAdornment position="start">
                        <EndIcon style={{ cursor: 'pointer' }} onClick={() => IconCallback()}/>
                    </InputAdornment>
                )
            }}
        />
    )
}

export default OneInput

/* Tutorial:
    As props para passar para o input são:
        - StartIcon: Icone que irá aparecer no começo do input. Deve ser passado apenas o nome do icone
        e ser importado onde está sendo chamado o input. ex: StartIcon={Apartment}
        - EndIcon: Mesmo que o StartIcon mas para o Fim.
        - name: nome da propriedade que será afetada no objeto form.
        - type: Tipo do componente. Caso não seja passado o default é text
*/
